import React from 'react';
import './UploadMediaOpenInNewTabLink.css';

/** External-link icon (same SVG as MyCoursesManager course builder row); stops parent card click. */
export default function UploadMediaOpenInNewTabLink({ href }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="upload-media-open-tab"
      title="Open in new tab"
      aria-label="Open media in new tab"
      onClick={(e) => e.stopPropagation()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="upload-media-open-icon"
        width={16}
        height={16}
        aria-hidden
      >
        <path d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
    </a>
  );
}
